import React, {Component} from 'react';
import {Elements, StripeProvider} from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm';
import requireAuth from './requireAuth';
import { connect } from 'react-redux';
import './StripeStyle.css';
import moment from 'moment-timezone';
import api from '../services/api';
import * as actions from '../actions';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';

const override = css`
    margin: 10px;
`;

class StripeComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: false
    };
  }

  componentDidMount() {
    this.props.getStripePlans();
  }

  cancelSubscription = async () => {
    this.setState({buttonDisabled: true});
    await this.props.deleteSubscription();

    this.setState({buttonDisabled: false});
    this.props.getUserPremiumStatus();
    this.props.getStripeDetails();

  }

  getPremiumSubscription = async () => {
    this.setState({buttonDisabled: true});
    await this.props.getFreeSubscription();

    this.setState({buttonDisabled: false});
    this.props.getUserPremiumStatus();
  }

  render() {
    const timezone = moment.tz.guess();

    if (this.props.premium === null) {
      return (
        <div className="flex-container"
          style={{
            alignItems: 'center',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
            textAlign: 'center',
            flexGrow: '1',
            height: '800px'
          }}
        >
          <div className="flex-container box" style={{ paddingLeft: '30px', paddingRight: '30px' }}>
            Loading...
          </div>
        </div>
      );
    }
    else if (this.props.premium === true) {
      return (
        <div className="flex-container"
          style={{
            alignItems: 'center',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
            textAlign: 'center',
            flexGrow: '1'
          }}
        >
          <div className="flex-container box" style={{ height: '200px', flexDirection: 'column', justifyContent: 'space-between' }}>
            {this.props.premium_source === 'stripe' &&
              <div>
                <div>Thank you for being an eaterpad Premium subscriber. You are currently signed up for the {this.props.nickname} plan.</div>
                <div>
                  If you just signed up, make sure to force-restart eaterpad on your mobile device so that your premium status can sync up.
                </div>
              </div>
            }
            {this.props.premium_source === 'ios' &&
              <div>Thank you for being an eaterpad Premium subscriber. You are signed up through iOS. Please manage your subscription in your iOS subscriptions.</div>
            }
            {this.props.premium_source === 'android' &&
              <div>Thank you for being an eaterpad Premium subscriber. You are signed up through Android. Please manage your subscription in your Android subscriptions.</div>
            }
            {this.props.premium_source === 'free' &&
              <div>You have been gifted eaterpad Premium for free. Enjoy!</div>
            }
            <div>
              Your current subscription cycle runs until {moment(this.props.current_period_end).local().format('YYYY-MM-DD')}.
            </div>
            {this.props.premium_source === 'stripe' &&
              (this.state.buttonDisabled ? (
                <ClipLoader
                  className={override}
                  sizeUnit={"px"}
                  size={30}
                  color={'#123abc'}
                />
              ) : (
                <button
                  onClick={this.cancelSubscription}
                  disabled={this.state.buttonDisabled}>
                  Cancel Subscription
                </button>
              ))
            }
          </div>
        </div>
      )
    } else {
      return (
        <StripeProvider apiKey="pk_live_kLzMv1nQYclFR9R1YJrSWoXa">
          <div className="flex-container"
            style={{
              alignItems: 'center',
              justifyContent: 'space-evenly',
              flexDirection: 'column',
              textAlign: 'center',
              flexGrow: '1',
              margin: '20px'
            }}
          >
            <Elements>
              <CheckoutForm location={this.props.location}/>
            </Elements>
            {(this.state.buttonDisabled ? (
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={30}
                color={'#123abc'}
              />
            ) : (
              <div style={{ fontSize: '14px', maxWidth: '500px' }}>
                eaterpad is an independent app built by a small team, focused on creating the best food tracker.
                We are committed to making a phenomenal free version.
                Your subscription enables us to continue making improvements to the app.
              </div>
            ))}
          </div>
        </StripeProvider>
      );
    }
  }
}

function mapStatetoProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user_email: state.auth.user_email,
    premium: state.premium.user_premium,
    premium_source: state.premium.premium_source,
    current_period_end: state.premium.current_period_end,
    nickname: state.premium.nickname
  };
}

export default requireAuth(connect(mapStatetoProps, actions)(StripeComponent));
